import { useCallback, useState } from "react";
import { motion } from "framer-motion";
import { Maximize2 } from "lucide-react";
import { resolveUrl } from "@/lib/api";
import { Lightbox } from "@/components/gallery/Lightbox";

const spans = ["sm:col-span-2 sm:row-span-2", "", "", "", ""];

export const PhotoTile = ({ photo, index, onOpen, className = "" }) => (
    <motion.button
        type="button"
        data-testid={`gallery-photo-${index}`}
        onClick={() => onOpen(index)}
        className={`group relative block h-full min-h-[220px] w-full overflow-hidden bg-tl-card text-left ${className}`}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.7, delay: 0.05 * (index % 6), ease: [0.22, 1, 0.36, 1] }}
    >
        <img
            src={resolveUrl(photo.url)}
            alt={photo.title || "Lavorazione TECNO-LAV"}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
        />
        <span className="absolute inset-0 bg-gradient-to-t from-tl-dark/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        <span className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
            <span className="font-mono-tl text-[11px] uppercase tracking-[0.25em] text-white">
                {photo.title}
            </span>
            <Maximize2 size={14} className="text-tl-orange" />
        </span>
        <span className="absolute left-3 top-3 font-mono-tl text-[10px] text-white/50">
            {String(index + 1).padStart(2, "0")}
        </span>
    </motion.button>
);

export const PhotoGrid = ({ photos }) => {
    const [active, setActive] = useState(null);
    const move = useCallback(
        (dir) => setActive((i) => (i == null ? i : (i + dir + photos.length) % photos.length)),
        [photos.length],
    );
    const close = useCallback(() => setActive(null), []);

    return (
        <>
            <div
                data-testid="gallery-grid"
                className="grid auto-rows-[240px] grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-4"
            >
                {photos.map((p, i) => (
                    <PhotoTile key={p.id} photo={p} index={i} onOpen={setActive} className={spans[i % spans.length]} />
                ))}
            </div>
            <Lightbox photos={photos} index={active} onClose={close} onMove={move} />
        </>
    );
};
